function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M335 176.431V152.472L389.723 74H422.8V150.736H437V176.431H422.8V199H393.187V176.431H335ZM395.265 106.639L366.171 150.736H395.265V106.639Z",
  fill: "#DFDFE2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M222.04 0C164.051 0 117 47.2972 117 105.59C117 163.883 164.051 211.18 222.04 211.18C251.799 211.18 278.823 198.81 297.804 178.678C302.389 173.827 298.85 165.904 292.335 165.904H244.48C236.196 165.904 229.44 159.112 229.44 150.785V135.666C229.44 127.339 236.196 120.547 244.48 120.547H311.96C320.244 120.547 327 113.756 327 105.428C327.08 47.2971 280.029 0 222.04 0ZM268.528 82.9519C263.541 82.9519 259.52 78.9094 259.52 73.8968C259.52 68.8841 263.541 64.8416 268.528 64.8416C273.515 64.8416 277.536 68.8841 277.536 73.8968C277.536 78.9094 273.515 82.9519 268.528 82.9519Z",
  fill: "#FF1919"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 176.431V152.472L54.7233 74H87.7997V150.736H102V176.431H87.7997V199H58.1868V176.431H0ZM60.2649 106.639L31.1715 150.736H60.2649V106.639Z",
  fill: "#DFDFE2"
});

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 212,
    viewBox: "0 0 437 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.e3d74e0d.svg";
export { ForwardRef as ReactComponent };